// ============================================================
// TMR Portal Admin — dados de referência do cadastro (UFs, origens)
// ============================================================
export const ESTADOS: { uf: string; n: string }[] = [
  { uf: 'AC', n: 'Acre' }, { uf: 'AL', n: 'Alagoas' }, { uf: 'AP', n: 'Amapá' }, { uf: 'AM', n: 'Amazonas' },
  { uf: 'BA', n: 'Bahia' }, { uf: 'CE', n: 'Ceará' }, { uf: 'DF', n: 'Distrito Federal' }, { uf: 'ES', n: 'Espírito Santo' },
  { uf: 'GO', n: 'Goiás' }, { uf: 'MA', n: 'Maranhão' }, { uf: 'MT', n: 'Mato Grosso' }, { uf: 'MS', n: 'Mato Grosso do Sul' },
  { uf: 'MG', n: 'Minas Gerais' }, { uf: 'PA', n: 'Pará' }, { uf: 'PB', n: 'Paraíba' }, { uf: 'PR', n: 'Paraná' },
  { uf: 'PE', n: 'Pernambuco' }, { uf: 'PI', n: 'Piauí' }, { uf: 'RJ', n: 'Rio de Janeiro' }, { uf: 'RN', n: 'Rio Grande do Norte' },
  { uf: 'RS', n: 'Rio Grande do Sul' }, { uf: 'RO', n: 'Rondônia' }, { uf: 'RR', n: 'Roraima' }, { uf: 'SC', n: 'Santa Catarina' },
  { uf: 'SP', n: 'São Paulo' }, { uf: 'SE', n: 'Sergipe' }, { uf: 'TO', n: 'Tocantins' },
];

export const ORIGENS: string[] = ['Indicação de parceiro', 'Prospecção ativa', 'Evento ou feira do setor', 'Inbound (site)', 'Renovação de carteira legada'];

// A classificação NÃO mora aqui. Ela é um item do dicionário compartilhado do legado (grupo 21), lido por
// `GET /companies/classifications` — ver `useClassifications`. As quatro constantes que ficavam nesta linha
// (`Diamante`/`Ouro`/`Prata`/`Bronze`) nasceram numa maquete e nunca corresponderam a nada no V1 (12 §1).

// Os bancos também não moram mais aqui. Eram onze constantes escritas à mão; o catálogo real vem do
// dicionário de bancos do legado por `GET /banks` — ver `useBanks`. Uma lista curta hard-coded significava
// que a conta de uma empresa cujo banco não estivesse nela simplesmente não podia ser cadastrada (13 §9).

